import * as React from "react";
const SvgChevronUp = (props) => /* @__PURE__ */ React.createElement("svg", { width: 10, height: 4, viewBox: "0 0 10 4", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M5 -4.37114e-07L0.669872 3.75L9.33013 3.75L5 -4.37114e-07Z", fill: "#9C9C9C" }));
export default SvgChevronUp;
